import React, { useContext, useEffect } from 'react';
import { AppContext, DispatchContext } from "../AppContext";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import * as actions from "../actions/actions";


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

export default function ToastrComponent() {
    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const duration = Math.max(4000, state.toastrAlert.message.length/100*5*1000);  // 5s per 100 chars (4s minimum)

    useEffect(() => {
        if (state.toastrAlert.status) {
            setOpen(true);
            dispatch(actions.openToast({...state.toastrAlert, status: false }));
        }
      }, [state.toastrAlert.status]);
        

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
          }        
        setOpen(false);
    };

    return (
        <div> {open ?  
            <Snackbar open={open} autoHideDuration={duration} onClose={handleClose}>
                <Alert onClose={handleClose} severity={state.toastrAlert.type}>
                    {state.toastrAlert.message}
                </Alert>
            </Snackbar>
            : null }
        </div>
    );
}